import { render } from "./ShowCategoryList.vue?vue&type=template&id=30c058da"
import script from "./ShowCategoryList.vue?vue&type=script&lang=ts"
export * from "./ShowCategoryList.vue?vue&type=script&lang=ts"
script.render = render

export default script